module.exports = __webpack_public_path__ + "img/web.64d5685c.png";